/**
 * Sheet component type definitions
 */

export enum SheetSide {
  Left = 'left',
  Right = 'right',
  Top = 'top',
  Bottom = 'bottom',
}

export enum SheetSize {
  Small = 'sm',
  Default = 'default',
  Medium = 'md',
  Large = 'lg',
  ExtraLarge = 'xl',
  Full = 'full',
}
